module.exports = __webpack_public_path__ + "img/puzzle.d43e3b2d.svg";